export const amountConstants = {
  GET_AMOUNT: 'GET_AMOUNT',
}
